import { Selector } from '@ngxs/store';
import { GuidedTourStateModel } from '../models/guided-tour-state.model';
import { GuidedTourState } from './guided-tour.state';

export class GuidedTourSelectors {
    @Selector([GuidedTourState])
    static toggleStatus(state: GuidedTourStateModel) {
        return state.toggleOn;
    }
}
